import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function RequestOpen({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.challengeRequestOpen"
      values={{
        name: util.getEventNames(events ?? []),
        challenge: ownerChallenge?.name || "Deleted",
      }}
    />
  );
}
